import { useState } from 'react'
import { getApiUrl } from '../../api'
import { useNavigate } from 'react-router-dom'
import TiptapEditor from '../../components/common/TiptapEditor'

export default function NoticeRegister() {
  const [title, setTitle] = useState('')
  const [isVisible, setIsVisible] = useState(1)
  const [files, setFiles] = useState<File[]>([])
  const [content, setContent] = useState('')
  const navigate = useNavigate()

  const handleSubmit = async () => {
    if (!title.trim()) { alert('제목을 입력해주세요.'); return }
    if (!content || content === '<p></p>') { alert('내용을 입력해주세요.'); return }

    const formData = new FormData()
    formData.append('title', title)
    formData.append('content', content)
    formData.append('is_visible', String(isVisible))
    files.forEach(file => formData.append('files', file))

    try {
      const token = localStorage.getItem('access_token')
      const res = await fetch(getApiUrl('/marubit/api/notice/admin'), {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      })
      if (!res.ok) throw new Error('등록 실패')
      const data = await res.json()
      alert(data.message)
      navigate('/notice')
    } catch {
      alert('공지사항 등록에 실패했습니다.')
    }
  }

  return (
    <div className="bg-[#fafafa] min-h-screen px-6 py-12">
      <div className="max-w-[1200px] mx-auto">

        <div className="mb-8">
          <h1 className="text-[26px] font-extrabold text-[#887267] mb-2">공지사항 등록</h1>
          <p className="text-[14px] text-gray-400">공지사항 정보를 입력하고 저장해주세요.</p>
        </div>

        {/* 제목 */}
        <div className="bg-white rounded-2xl p-7 mb-4 f8b62cshadow-[0_2px_12px_rgba(136,114,103,0.06)]">
          <h2 className="text-[16px] font-bold text-[#887267] border-l-[3px] border-[#887267] pl-[10px] mb-4">제목</h2>
          <input
            type="text"
            placeholder="공지사항 제목을 입력해주세요 *"
            value={title}
            onChange={e => setTitle(e.target.value)}
            className="w-full px-4 py-3 text-[14px] border-[1.5px] border-gray-200 rounded-[10px] outline-none focus:border-[#887267] transition-colors"
          />
        </div>

        {/* 내용 */}
        <div className="bg-white rounded-2xl p-7 mb-4 f8b62cshadow-[0_2px_12px_rgba(136,114,103,0.06)]">
          <h2 className="text-[16px] font-bold text-[#887267] border-l-[3px] border-[#887267] pl-[10px] mb-4">내용</h2>
          <TiptapEditor
            onChange={setContent}
            imageUploadUrl="/marubit/api/notice/admin/upload-image"
          />
        </div>

        {/* 첨부파일 */}
        <div className="bg-white rounded-2xl p-7 mb-4 f8b62cshadow-[0_2px_12px_rgba(136,114,103,0.06)]">
          <h2 className="text-[16px] font-bold text-[#887267] border-l-[3px] border-[#887267] pl-[10px] mb-1">첨부파일</h2>
          <p className="text-[12px] text-gray-400 ml-[13px] mb-4">최대 5개까지 첨부 가능합니다.</p>
          <input
            type="file"
            multiple
            onChange={e => {
              const selected = Array.from(e.target.files ?? [])
              const merged = [...files, ...selected]
              if (merged.length > 5) {
                alert('첨부파일은 최대 5개까지 가능합니다.')
                setFiles(merged.slice(0, 5))
              } else {
                setFiles(merged)
              }
              e.target.value = ''
            }}
            className="block text-[13px] text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-[13px] file:font-semibold file:bg-[#f5f2f0] file:text-[#887267] hover:file:bg-[#e8e0dc] cursor-pointer"
          />
          {files.length > 0 && (
            <ul className="mt-3 space-y-2">
              {files.map((f, i) => (
                <li key={i} className="flex items-center justify-between text-[13px] text-gray-500 bg-gray-50 rounded-lg px-3 py-2">
                  <span className="flex items-center gap-2"><span className="text-[#887267]">📎</span>{f.name}</span>
                  <button onClick={() => setFiles(files.filter((_, idx) => idx !== i))} className="text-[12px] text-red-400 hover:text-red-600 ml-4">삭제</button>
                </li>
              ))}
            </ul>
          )}
          <p className="mt-2 text-[12px] text-gray-300">{files.length}/5</p>
        </div>

        {/* 노출 여부 */}
        <div className="bg-white rounded-2xl p-7 mb-6 f8b62cshadow-[0_2px_12px_rgba(136,114,103,0.06)]">
          <h2 className="text-[16px] font-bold text-[#887267] border-l-[3px] border-[#887267] pl-[10px] mb-4">노출 여부</h2>
          <label className="flex items-center gap-3 cursor-pointer px-4 py-3 bg-[#f5f2f0] rounded-[10px] border border-[#e8e0dc] w-fit">
            <input
              type="checkbox"
              checked={isVisible === 1}
              onChange={e => setIsVisible(e.target.checked ? 1 : 0)}
              className="w-4 h-4 cursor-pointer accent-[#887267]"
            />
            <span className="text-[13px] font-semibold text-[#887267]">노출</span>
          </label>
        </div>

        <button
          onClick={handleSubmit}
          className="w-full h-[52px] bg-[#887267] text-white border-none rounded-xl text-[16px] font-bold cursor-pointer hover:bg-[#6b5248] transition-colors shadow-[0_4px_16px_rgba(136,114,103,0.25)]"
        >
          저장
        </button>
      </div>
    </div>
  )
}